function identity(x) {
  return x;
}

if (!Array.prototype.groupBy) {
  Array.prototype.groupBy = function (fKey, fValue) {
    fValue = fValue || identity;

    var groups = [];
    var content;
    this.forEach(function (entry) {
      var key = fKey(entry);
      groups[key] = content = (groups[key] || []);
      content.push(fValue(entry));
    });

    return groups;
  };
}

Array.range = function (n) {
  var arr = new Array(n);
  for (var i = 0; i < n; i++)
    arr[i] = i;
  return arr;
};

Array.concat = function (arrays) {
  return [].concat.apply([], arrays);
};

Math.round10 = function (value) {
  value = +value;
  value = value.toString().split('e');
  value = Math['round'](+(value[0] + 'e' + (value[1] ? (+value[1] + 2) : 2)));

  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] - 2) : -2));
};
